import React from 'react';
import { DayViewDetail } from '../../../components/crm-calender/DayViewDetail';
import { Box, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const DayViewSummary = ({ date, appointments, setOpenAppointmentDetail}) => {
    //console.log(appointments)
    // Transform the appointments data to match the expected format
    const transformedAppointments = appointments?.length > 0
        ? appointments.map(appointment => ({
            id: appointment?.id,
            customer: {
                name: appointment?.customer?.name || 'No Name',
                ...appointment.customer
            },
            start_time: appointment.start_time,
            end_time: appointment.end_time,
            services: appointment?.service_name || [],
            type: appointment.type || 'Booking',
            notes: '',
            staff_name: appointment.staff_name || 'Staff Not Assigned',
            staff_color: appointment.staff_color || '#000000',
            status_color: appointment.status_color || '#323681',
            opacity_color: appointment.opacity_color || '#3236817f',
            payment_status: appointment.payment_status || 'Unpaid'
        }))
        : []; // Return empty array if no appointments

    return (
        <Box className="container-fluid mx-auto" sx={{ py:{sm:4, xs:.2}, width:'100%', minWidth:0, overflowX:'hidden' }}>
            <Box sx={{ my: { sm: 3, xs: 2 }, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'flex-start' }, gap: { xs: 1.5, sm: 2 }, flexWrap: 'wrap' }}>
                <Box sx={{ minWidth: 0 }}>
                    <Typography variant="h4" className="font-bold" sx={{ fontSize:{sm:'2rem', xs:'1.25rem'}, fontWeight:'bold', color: '#1a1a2e' }}>
                        Daily Appointment Summary
                    </Typography>
                    <Typography sx={{ display: 'flex', alignItems: 'center', gap: 0.75, fontSize: { sm: '1rem', xs: '0.9rem' }, color: '#6B7280', mt: 0.75, flexWrap: 'wrap', wordBreak: 'break-word' }}>
                        <CalendarMonthIcon sx={{ color:'#A72C68', fontSize: { sm: 20, xs: 16 } }}/>
                        Appointments for {date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
                    </Typography>
                </Box>

                <Box sx={{
                    display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0,
                    background: '#fff', border: '1px solid #F0E0E9', borderRadius: '14px',
                    px: 2, py: 1.25, boxShadow: '0 2px 10px rgba(15,23,42,0.05)',
                }}>
                    <Box sx={{
                        width: 42, height: 42, borderRadius: '12px', background: '#A72C68',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    }}>
                        <CalendarMonthIcon sx={{ color: '#fff', fontSize: 22 }}/>
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: '1.4rem', fontWeight: 800, color: '#A72C68', lineHeight: 1 }}>
                            {appointments.length}
                        </Typography>
                        <Typography sx={{ fontSize: '0.8rem', color: '#6B7280', fontWeight: 500 }}>
                            Today's Appointments
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <DayViewDetail
           setOpenAppointmentDetail={setOpenAppointmentDetail}
                appointments={transformedAppointments}
                date={date}
            />

        </Box>
    );
};

export default DayViewSummary;